module.exports = __webpack_public_path__ + "img/menu-hair-10.dfe0deb1.jpg";